import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CrookedStar, FourPointStar } from "../../../assets";
import { getReadinessPlacementResult } from "../../../hooks/useApi";

const PLACEMENT_TOTAL_QUESTIONS_KEY = "placement_total_questions";

const PlacementIntro = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const placementResultId = searchParams.get("placement_result_id") || "";
  const totalQuestions = Number(searchParams.get("total_questions") || localStorage.getItem(PLACEMENT_TOTAL_QUESTIONS_KEY) || 0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [placementData, setPlacementData] = useState(null);

  useEffect(() => {
    const fetchPlacementResult = async () => {
      if (!placementResultId) {
        setError("Placement result tidak ditemukan. Silakan kembali ke hasil tes.");
        setLoading(false);
        return;
      }

      try {
        const data = await getReadinessPlacementResult(placementResultId);
        setPlacementData(data);
      } catch (err) {
        setError("Gagal memuat ringkasan placement test. Silakan coba lagi.");
      } finally {
        setLoading(false);
      }
    };

    fetchPlacementResult();
  }, [placementResultId]);

  const goToReadinessChecker = () => {
    if (!placementResultId) {
      navigate("/readiness-checker");
      return;
    }

    navigate(`/readiness-checker?entry_path=from_placement&placement_result_id=${placementResultId}`);
  };

  return (
    <div className="min-h-fit bg-[--st-color-cream] overflow-hidden px-4 py-6 sm:py-8">
      <div className="mx-auto w-full max-w-5xl relative overflow-visible font-poppins">
        <div className="pointer-events-none absolute inset-0 z-0 hidden sm:block" aria-hidden="true">
          <img
            src={FourPointStar}
            alt=""
            className="absolute left-[-74px] top-[86px] w-[102px] md:left-[-92px] md:w-[120px]"
            loading="lazy"
          />
          <img
            src={CrookedStar}
            alt=""
            className="absolute bottom-[28px] right-[-88px] w-[128px] md:right-[-100px] md:w-[146px]"
            loading="lazy"
          />
        </div>

        <div className="relative z-10 px-2 py-4 sm:px-4 sm:py-6 md:px-8 md:py-10">
          <div className="max-w-[860px] mx-auto">
            <div className="mb-6 sm:mb-8">
              <div className="flex items-start gap-3">
                <span className="mt-3 h-4 w-4 rounded-full bg-[--st-color-program-red]" />
                <div>
                  <h1 className="text-[26px] font-extrabold leading-tight text-[#1F1F1F] sm:text-[32px]">
                    Tes kemampuan bahasa Inggrismu!
                  </h1>
                  <p className="mt-2 max-w-[720px] text-[16px] leading-[1.5] text-[#3E3E3E] sm:text-[18px]">
                    Karena kamu belum punya skor IELTS, kami menggunakan hasil placement test ini untuk melihat sejauh mana kesiapanmu.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-[28px] bg-[--st-color-program-red] px-6 py-8 text-center text-white shadow-[0_16px_30px_rgba(0,0,0,0.12)] sm:px-10 sm:py-10">
              <p className="text-[24px] font-bold leading-none sm:text-[30px]">Hasil placement test</p>
              <p className="mt-3 text-[16px] leading-tight sm:text-[18px]">
                Berdasarkan {totalQuestions || "-"} soal yang sudah kamu kerjakan, ini hasilmu:
              </p>

              {loading ? (
                <p className="mt-8 text-[18px] font-medium sm:text-[20px]">Memuat hasil placement test...</p>
              ) : error ? (
                <p className="mt-8 text-[18px] font-medium text-[#FFE4E1] sm:text-[20px]">{error}</p>
              ) : (
                <>
                  <p className="mt-6 text-[72px] font-extrabold leading-none tracking-tight sm:mt-8 sm:text-[96px] md:text-[112px]">
                    {placementData?.raw_score ?? "-"}
                  </p>
                  <p className="mt-4 text-[18px] leading-tight sm:text-[22px]">
                    Perkiraan skor IELTS: Band ~{placementData?.estimated_ielts_band ?? "-"}
                  </p>
                  <p className="mt-3 text-[14px] leading-snug text-[#FFF2ED] sm:text-[15px]">
                    Skor ini akan kami gunakan sebagai acuan untuk mengecek kesiapanmu ke tahap berikutnya!
                  </p>
                </>
              )}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={goToReadinessChecker}
                className="st-focus-ring st-readiness-next px-8 py-3 text-[16px] font-bold text-white transition-colors sm:px-10 sm:text-[18px]"
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlacementIntro;